import type { FrontendOnlyPieces } from '../../../hooks/useSettings/WebsiteSettings';
import { WalnutPartnersFooter } from '../Footer';

// Walnut MerchantGrowth — frontend-only pieces; all data fields live on the backend
export const walnutMerchantGrowthFrontend: FrontendOnlyPieces = {
  slug: 'walnutmerchantgrowth',
  Footer: WalnutPartnersFooter,
};
